// ===== ADD HERE ALL THE API CALLS TO BE =====

// THE COMPONENT HAS ACCESS TO PROPS FROM APPCONFIG (IDPUSHTTL, IDJOURNEY) AND CAN SET THE STATE OF THE APPLICATION (CFR. APPCONTAINER)
// THE COMPONENT IS THOUGHT TO RE-RENDER WHEN IDPUSHTTL OR IDJOURNEY CHANGE CAUSING THE WHOLE APP TO RERENDER.
// IF IT IS NECESSARY TO AVOID THIS BEHAVIOUR REMOVE THE USESTATE FROM THIS COMPONENT. AND PASS IDPUSHTTL AND IDJOURNEY FROM THE CALLER
// (REMOVING THE STATE WILL CAUSE ERRORS, ALL COMPONENTS MUST THEN PASS THE TWO PARAMETERS)

import { Children, isValidElement, cloneElement, useState, useEffect, useCallback, useMemo } from 'react';
import * as api from '../api/api';
import { fromResponseToState, initialState, createCustomAlert } from '../utils/utils';

function ApiHandlers(props) {
  const { setState, children, idPushTTL, idJourney, copiedKeyJourney, version, updateActivityConfig, updateAppConfig } = props;

  // GROUP APPCONFIG (IDPUSHTTL, IDJOURNEY, VERSION) INTO ONE OBJECT THAT CAN BE USED WHEN CALLING BACKEND
  const [activityParams, setActivityParams] = useState({ key: { idPushTTL: '', idJourney: '', version: 0 } });

  // const [firstRenderGetTemplate, setFirstRenderGetTemplate] = useState(false);

  const [loading, setLoading] = useState(false);

  // WHEN APPCONFIG (IDPUSHTTL, IDJOURNEY, VERSION) IS EDITED THE UPDATES ARE REFLECTED INTO THE INTERNAL STATE (ACTIVITYPARAMS)
  useEffect(() => {
    setActivityParams({ key: { idPushTTL, idJourney, version } })
  }, [idPushTTL, idJourney, version]);

  // useEffect(() => {
  //   if (firstRenderGetTemplate && activityParams.key.idPushTTL && activityParams.key.idJourney) {
  //     getTemplate();
  //   }
  // }, [firstRenderGetTemplate, activityParams.key.idPushTTL, activityParams.key.idJourney])
  
  // GET SAVED TEMPLATE INFO IF PRESENT, IF NOT START A NEW TEMPLATE
  const getTemplate = useCallback(async () => {

    // on first render activityParams are empty
    if (activityParams.key.idPushTTL && activityParams.key.idJourney) {
      let params = Object.assign({}, activityParams);
      // if the journey has been copied the parameters to call BE should be the old ones
      if (copiedKeyJourney.idJourney && copiedKeyJourney.idJourney !== 'id-journey' && copiedKeyJourney.idJourney !== activityParams.key.idJourney) {
        params.key = copiedKeyJourney;
        createCustomAlert('ATTENZIONE!','Per ogni nuova versione o copia di un Journey è <strong>MANDATORIO</strong> effettuare il salvataggio manuale di TUTTE le custom activity presenti nel canvas<br/><br/>Ti invitiamo quindi a cliccare su OK e poi su SALVA sia in questa che in tutte le altre istanze che trovi nel canvas prima di attivare la Journey', 'ok');
      }
      setLoading(true);
      const { response, error } = await api.retrieveTemplate(params);
      setLoading(false);

      // if (firstRenderGetTemplate) setFirstRenderGetTemplate(false);

      if (!error && !response.sso) {
        // flagClonedTemplate is true if the journey has been versioned
        if (response.data.flagClonedTemplate) {
          createCustomAlert('ATTENZIONE!','Per ogni nuova versione o copia di un Journey è <strong>MANDATORIO</strong> effettuare il salvataggio manuale di TUTTE le custom activity presenti nel canvas<br/><br/>Ti invitiamo quindi a cliccare su OK e poi su SALVA sia in questa che in tutte le altre istanze che trovi nel canvas prima di attivare la Journey', 'ok');
        }
        if (response.data.flagNewTemplate) {
          // ====== replace the mock idpushTTL with one progressivly numbered (ONLY FOR TESTING) ======
          if (activityParams.key.idPushTTL === 'REST-TEST') updateAppConfig(`REST-${response.data.testCounter}`);
          // ====== ======
          setState(prev => ({ ...prev, values: initialState, slots: {...prev.slots, flagNewTemplate: response.data.flagNewTemplate} }));
        } else {
        setState(prev => ({
            ...prev,
            values: {
              ...initialState,
              ...fromResponseToState(response.data.templateInfo),
              newTemplate: false
            },
            slots: {
              ...prev.slots,
              flagNewTemplate: response.data.flagNewTemplate
            }
          }));
        };
      } else {
        createCustomAlert('Ops!','Errore durante il caricamento delle informazioni della campagna. Riprovare più tardi!');
      }
    }
  // including updateAppConfig (used only during testing) in the deps causes the function to be called multiple times (the param changes) 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setState, activityParams, copiedKeyJourney]);

    // GET ENUMS
  const getMarketingAutomationInfo = useCallback(async () => {
    setLoading(true);
    const { response, error } = await api.getMarketingAutomationInfo();
    setLoading(false);

    if (!error && !response.sso) {
      setState(prev => ({ ...prev, info: response.data.mktaInfo }));
      // setFirstRenderGetTemplate(true);
    } else {
      createCustomAlert('Ops!','Errore durante il caricamento dei dati. Riprovare più tardi!');
    }
  }, [setState]);
  
  // SAVE CURRENT TEMPLATE AND UPDATE ACTIVITYCONFIG(POSTMONGER)
  const saveTemplate = useCallback(async (templateInfo) => {
    console.warn('save template: ', templateInfo);
    console.warn('save activityParams: ', activityParams)
    setLoading(true);
    const { response, error } = await api.saveTemplate({ ...activityParams, templateInfo });
    setLoading(false);

     if (!error && !response.sso) {
      // see App.js sets config in Postmonger
      setState(prev => ({ ...prev, values: { ...prev.values, newTemplate: false } }));
      updateActivityConfig();
    } else {
      if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok');
      } else {
        createCustomAlert('Ops!', 'Errore durante il salvataggio della campagna. Riprovare più tardi!', 'ok');
      }
    }
  }, [activityParams, setState, updateActivityConfig]);
  
  // ====== ONLY FOR TESTING: STARTS A CAMPAIGN ====== 
  const startCampaign = useCallback(async (idUser) => {
      let analyticsInfo = {};
      let navigationInfo = {};
      let dateInfo = {};
      let dynamicParams = {};
      let queryParams = {};

    const { error } = await api.startCampaign(
      {
        inArguments: [{ idUser }, { analyticsInfo }, {navigationInfo}, { dateInfo }, { dynamicParams }, { queryParams }, { ...activityParams }]
      }
    );
    if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
      createCustomAlert('Ops!', error.response.data.mainError.message, 'ok');
    }

    // returns a boolean to set for what users the campaign didn't start correctly in the component
    return !Boolean(error);
  }, [activityParams]);
  
  // ====== ONLY FOR TESTING: GET LIST OF ALREADY SAVED IDPUSHTTL====== 
  const retrieveIds = useCallback(async () => {
    const { response, error } = await api.retrieveIds();

     if (!error && !response.sso) {
      return response.data.idsPushTTL.reverse();
    } else {
      createCustomAlert('Ops!', 'Errore durante il recupero degli id. Riprovare più tardi!', 'ok');
      return;
    }
  }, []);

  const getBannerQueue = useCallback(async (setBannerQueueModalIsVisible) => {

    const payload = {
      idJourney: activityParams.key.idJourney,
      version: activityParams.key.version
    }

    setLoading(true);
    const { response, error } = await api.getBannerQueue(Object.assign({}, payload));
    setLoading(false);

    if (!error && !response.sso) {
      return response;
    } else {
      if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok', () => setBannerQueueModalIsVisible(false));
      } else {
        createCustomAlert('Ops!', 'Errore durante il recupero della campagna. Riprovare più tardi!', 'ok', () => setBannerQueueModalIsVisible(false));
      }
    }
  }, [activityParams]);

  const getRunningCampaignVersions = useCallback(async (setRetrieveBannerIsVisible, templateType) => {

    const payload = {
      idJourney: activityParams.key.idJourney,
      templateType: templateType
    };
    setLoading(true);
    const { response, error } = await api.getRunningCampaignVersions(payload);
    setLoading(false);

    if (!error && !response.sso) {
      return response;
    } else {
      if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok', () => setRetrieveBannerIsVisible(false));
      } else {
        createCustomAlert('Ops!', 'Errore durante il recupero della campagna. Riprovare più tardi!', 'ok', () => setRetrieveBannerIsVisible(false));
      }
    }
  }, [activityParams]);

  const getRunningConfiguration = useCallback(async (selectedVersion, templateType) => {

    const payload = {
      idJourney: activityParams.key.idJourney,
      version: selectedVersion,
      templateType: templateType
    }

    setLoading(true);
    const { response, error } = await api.getRunningConfiguration(payload);
    setLoading(false);

    if (error && response.sso) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.mainError &&
        error.response.data.mainError.message
      ) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok');
      } else {
        createCustomAlert(
          'Ops!',
          'Errore durante il recupero della campagna. Riprovare più tardi!',
          'ok'
        );
      }
      return;
    }

      const slots = response?.data?.slots || {};

      const normalizedSlots = {};
      Object.keys(slots).forEach(slotName => {
        const slotArray = slots[slotName] || [];

        normalizedSlots[slotName] = slotArray.map(el => ({
          key: el.key,
          templateInfo: fromResponseToState(el.templateInfo)
        }));
      });

      setState(prev => ({
        ...prev,
        slots: {
          ...(prev.slots || {}),
          ...normalizedSlots
        }
      }));

      return response;
    },
    [activityParams, setLoading, setState]
  );

  const deleteSingleTemplate = useCallback(async (params) => {
    setLoading(true);
    const { response, error } = await api.deleteSingleTemplate(params);
    setLoading(false);

    if (!error && !response.sso) {
      return response;
    } else {
      if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok');
      } else {
        createCustomAlert('Ops!', 'Errore durante la cancellazione del banner selezionato. Riprovare più tardi!', 'ok');
      }
    }
  },[]);

  const updateTemplate = useCallback(async (params) => {
    setLoading(true);
    const { response, error } = await api.updateTemplate(params);
    setLoading(false);

    if (!error && !response.sso) {
      return response;
    } else {
      if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok');
      } else {
        createCustomAlert('Ops!', 'Errore durante la modifica della data di fine campagna. Riprovare più tardi!', 'ok');
      }
    }
  },[]);

  const deleteCampaign = useCallback(async (params) => {
    setLoading(true);
    const { response, error } = await api.deleteCampaign(params);
    setLoading(false);

    if (!error && !response.sso) {
      return response;
    } else {
      if (error && error.response && error.response.data && error.response.data.mainError && error.response.data.mainError.message) {
        createCustomAlert('Ops!', error.response.data.mainError.message, 'ok');
      } else {
        createCustomAlert('Ops!', 'Errore durante la cancellazione della campagna. Riprovare più tardi!', 'ok');
      }
      api.getRunningConfiguration(params);
    }
  },[]);

  // USEMEMO AVOIDS RE-RENDERING
  const apiHandlers = useMemo(() => {
    return ({
      getMarketingAutomationInfo,
      getTemplate,
      saveTemplate,
      retrieveIds,
      startCampaign,
      getBannerQueue,
      getRunningCampaignVersions,
      getRunningConfiguration,
      deleteSingleTemplate,
      updateTemplate,
      deleteCampaign
    });
  }, [getMarketingAutomationInfo, getTemplate, saveTemplate, retrieveIds,
        startCampaign, getBannerQueue, getRunningCampaignVersions, getRunningConfiguration,
        deleteSingleTemplate, updateTemplate, deleteCampaign]);

  // PASS THE API HANDLER AND LOADER TO THE MAIN COMPONENT AND TESTING POPUP
  const childrenWithProps = Children.map(children, child => {
    if (isValidElement(child)) {
      return cloneElement(child, { api: apiHandlers, loading });
    }
    return child;
  });

  return (
    <>
      {childrenWithProps}
    </>
  )
}

export default ApiHandlers;